import React from "react";
import { Wifi, WifiOff, Check, RefreshCw, AlertCircle } from "lucide-react";

/**
 * v6 F5 — Lichte UX-feedback over de save-status. Bouwt op de bestaande
 * `syncStatus` state in PaintMeasure (synced / saving / local / offline)
 * zonder de save/autosave-flow zelf aan te raken.
 *
 * Geen externe telemetry, geen logging — enkel een sticker in de header
 * zodat testers vertrouwen hebben dat hun werk veilig bewaard is.
 */
export default function SyncStatusBadge({ status, online, dirty }) {
  // Bepaal welke staat geprioriteerd moet worden.
  //   Offline   ⟶ rood   (verbinding weg)
  //   Saving    ⟶ amber  (PUT in flight)
  //   Local     ⟶ amber  (dirty, save volgt automatisch)
  //   Synced    ⟶ groen  (alles opgeslagen)
  let label, sub, Icon, cls, spinning = false;

  if (!online) {
    label = "Offline";
    sub = "Wijzigingen worden bewaard zodra je terug online bent.";
    Icon = WifiOff;
    cls = "bg-[#FEEEED] text-[#C0392B] border-[#C0392B]/30";
  } else if (status === "saving") {
    label = "Bezig met opslaan…";
    sub = "Even geduld — je wijzigingen worden veilig bewaard.";
    Icon = RefreshCw;
    cls = "bg-[#FDF0E0] text-[#7F4124] border-[#D4A373]/40";
    spinning = true;
  } else if (status === "local" || dirty) {
    label = "Lokale wijzigingen niet gesynchroniseerd";
    sub = "Wordt automatisch opgeslagen — wacht even of tik op Opslaan.";
    Icon = AlertCircle;
    cls = "bg-[#FFF8EB] text-[#8A6E3F] border-[#E4B16D]/40";
  } else {
    label = "Gesynchroniseerd";
    sub = "Alle wijzigingen zijn veilig bewaard.";
    Icon = Check;
    cls = "bg-[#E8F1E8] text-[#3E6B3E] border-[#6B8E6B]/30";
  }

  return (
    <span
      className={`inline-flex items-center gap-1.5 mt-2 px-2.5 py-1 rounded-full border text-[11px] font-medium transition-colors duration-200 ${cls}`}
      data-testid="sync-status"
      data-sync-state={!online ? "offline" : status === "saving" ? "saving" : (status === "local" || dirty) ? "local" : "synced"}
      title={sub}
      aria-label={`${label}. ${sub}`}
    >
      <Icon className={`w-3 h-3 ${spinning ? "animate-spin" : ""}`} aria-hidden="true" />
      {label}
      {online && status !== "saving" && (status === "local" || dirty) && (
        <span className="ml-1 inline-flex items-center gap-1 text-[10px] opacity-70">
          <Wifi className="w-2.5 h-2.5" />
        </span>
      )}
    </span>
  );
}
